import React from 'react';
import styled from 'styled-components';
import {media} from '../modules/styles';

export default function MobileOnly({children}) {
  return <Comp>{children}</Comp>;
}

const Comp = styled.span`
  display: inline;

  @media (min-width: ${media.xl}) {
    display: none;
  }
`;
